import { Typography } from 'antd';
import styled from 'styled-components';

const { Text } = Typography;

export const StyledText = styled(Text)`
  font-size: 10px !important;
  color: #000 !important;
  font-weight: 400 !important;
  
  .anticon-copy,
  .anticon-check {
    color: #F78E1E !important;
    font-size: 10px !important;
    margin-left: 4px;
    border: 1px solid #F78E1E;
    padding: 2px;
  }
  
  .ant-typography-copy {
    color: #F78E1E !important;
  }
  
  .ant-typography-copy:hover {
    color: #e67e22 !important;
  }
`;
